"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var temp = function CustomerserviceTwotTwoTone(primaryColor, secondaryColor) {
    return {
        name: 'customerservice-twot',
        theme: 'twotone',
        nameWithTheme: 'customerservice-twot-twotone',
        tag: 'svg',
        attrs: {
            xmlns: 'http://www.w3.org/2000/svg',
            class: 'icon',
            viewBox: '0 0 1024 1024'
        },
        children: [
            {
                tag: 'path',
                attrs: {
                    fill: secondaryColor,
                    d: 'M696 632h128v192H696zm-496 0h128v192H200z'
                },
                children: []
            },
            {
                tag: 'path',
                attrs: {
                    d: 'M512 128c-212.1 0-384 171.9-384 384v360c0 13.3 10.7 24 24 24h184c35.3 0 64-28.7 64-64V624c0-35.3-28.7-64-64-64H200v-48c0-172.3 139.7-312 312-312s312 139.7 312 312v48H688c-35.3 0-64 28.7-64 64v208c0 35.3 28.7 64 64 64h184c13.3 0 24-10.7 24-24V512c0-212.1-171.9-384-384-384zM328 632v192H200V632h128zm496 192H696V632h128v192z',
                    fill: primaryColor
                },
                children: []
            }
        ]
    };
};
temp.nameWithTheme = 'customerservice-twot-twotone';
var CustomerserviceTwotTwoTone = temp;
exports.default = CustomerserviceTwotTwoTone;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@ant-design/icons/lib/twotone/CustomerserviceTwotTwoTone.js
// module id = 1293
// module chunks = 0